(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/popover/assets/javascripts/react-popover.js') >= 0) return;  svs.modules.push('/components/components/popover/assets/javascripts/react-popover.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useRef = _React.useRef,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useLayoutEffect = _React.useLayoutEffect;
const ReactPopover = _ref => {
  let children = _ref.children,
    arrowBranding = _ref.arrowBranding,
    triggerContent = _ref.triggerContent,
    triggerClass = _ref.triggerClass,
    visible = _ref.visible,
    title = _ref.title,
    position = _ref.position,
    branding = _ref.branding,
    arrowoffset = _ref.arrowoffset,
    offset = _ref.offset,
    closeOnOutsideClick = _ref.closeOnOutsideClick,
    speechBubble = _ref.speechBubble,
    showCloseIcon = _ref.showCloseIcon,
    speechBubbleAlignment = _ref.speechBubbleAlignment,
    onBeforeClose = _ref.onBeforeClose,
    onClose = _ref.onClose,
    onBeforeShow = _ref.onBeforeShow,
    onShow = _ref.onShow,
    onBeforeHide = _ref.onBeforeHide,
    onHide = _ref.onHide,
    onBeforeInit = _ref.onBeforeInit,
    onInit = _ref.onInit;
  const _useState = useState(visible),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  const popRef = useRef();
  const targetRef = useRef();
  const contentRef = useRef();
  const speechClass = "popover-speech-bubble-react ".concat(show ? 'show-popover' : 'hide-popover');
  const mainClassNames = "popover ".concat(speechBubble ? '' : "popover-".concat(position), " ").concat(speechBubble ? speechClass : branding, " animate ").concat(show || speechBubble ? 'popover-active' : '');
  const titleObject = React.createElement("p", {
    className: "popover-title"
  }, title);
  let Popover;
  let targetObj;
  const width = useRef(0);
  const height = useRef(0);
  function display() {
    let runEvents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (runEvents) {
      onBeforeShow();
    }
    if (speechBubble) {
      popRef.current.style.display = '';
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          popRef.current.style.width = "".concat(width.current, "px");
          popRef.current.style.height = "".concat(height.current, "px");
        });
      });
    }
    setShow(true);
    if (runEvents) {
      onShow();
    }
  }
  function hide() {
    let runEvents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (runEvents) {
      onBeforeHide();
    }
    if (speechBubble) {
      contentRef.current.style.opacity = 0;
      popRef.current.style.width = '0';
      popRef.current.style.height = '0';
    }
    setShow(false);
    if (runEvents) {
      onHide();
    }
  }
  function close() {
    let runEvents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (runEvents) {
      onBeforeClose();
    }
    hide(runEvents);
    if (runEvents) {
      onClose();
    }
  }
  function start(pop, tar, off) {
    Popover = pop;
    targetObj = tar;
    const offset = off;
    let css = {};
    const boundingClient = targetObj.getBoundingClientRect();
    const target = {};
    const arrowObj = Popover.querySelectorAll('.arrow')[0];
    onBeforeInit();
    target.width = targetObj.offsetWidth;
    target.height = targetObj.offsetHeight;
    target.offset = {
      top: boundingClient.top + window.scrollY,
      left: boundingClient.left + window.scrollX
    };
    target.pos = {
      top: targetObj.offsetTop,
      left: targetObj.offsetLeft
    };
    function calculateSpeechBubblePosition(css) {
      const targetLeft = target.offset.left + target.width / 2;
      const targetTop = target.offset.top;
      const objWidth = width.current;
      const objHeight = height.current;
      const containerWidth = Popover.parentElement.parentElement.offsetWidth;
      if (speechBubbleAlignment === 'bottom') {
        if (targetTop - 12 > objHeight) {
          css.top = target.height + 12;
          arrowObj.classList.add('arrow-top');
        } else {
          css.top = 'auto';
          css.bottom = target.height + 12;
        }
        if (containerWidth - (targetLeft + objWidth) >= 0) {
          css.left = target.pos.left + target.width / 2 + offset.left - objWidth / 2;
          arrowObj.style.left = "".concat(5 + arrowoffset, "px");
        } else if (targetLeft - objWidth >= 0) {
          css.left = 'auto';
          css.right = target.pos.left + target.width / 2 + offset.left - objWidth / 2;
          arrowObj.style.right = 0;
          arrowObj.style.left = 'auto';
          arrowObj.classList.add('arrow-right');
        } else {
          css.right = 'auto';
          css.left = target.offset.left * -1 + 20;
          css.bottom = target.height;
          arrowObj.style.left = "".concat(targetLeft - 20, "px");
          arrowObj.classList.add('arrow-center');
        }
      } else if (speechBubbleAlignment === 'left') {
        arrowObj.classList.add('arrow-top-right');
        css.bottom = 'auto';
        css.top = offset.top + 2;
        css.left = 'auto';
        css.right = target.width + offset.left + 14;
      } else if (speechBubbleAlignment === 'right') {
        arrowObj.classList.add('arrow-top-left');
        css.bottom = 'auto';
        css.top = offset.top + 2;
        css.right = 'auto';
        css.left = target.width + -offset.left + 12;
      } else if (speechBubbleAlignment === 'top') {
        css.bottom = target.height + offset.top + 6;
        css.left = target.width / 4 + -offset.left;
        css.top = 'auto';
      }
      css.zIndex = '1000';
      return css;
    }
    function reposition(css) {
      const arrowCorrection = 0;
      switch (position) {
        case 'right':
          css.top = target.height / 2 + -offset.top - height.current / 2;
          css.left = target.width + -offset.left;
          arrowObj.style.top = "".concat(height.current / 2 + (arrowoffset + arrowCorrection), "px");
          break;
        case 'bottom':
          css.top = target.height + -offset.top;
          css.left = target.width / 2 + -offset.left - width.current / 2;
          arrowObj.style.left = "".concat(width.current / 2 + (arrowoffset + arrowCorrection), "px");
          break;
        case 'bottom-left':
          css.top = -3 + target.height + -offset.top;
          css.left = 'auto';
          css.right = -offset.left;
          arrowObj.style.left = 'auto';
          arrowObj.style.right = '10px';
          break;
        case 'bottom-right':
          css.top = target.height + -offset.top - 3;
          css.left = -offset.left;
          arrowObj.style.left = '12px';
          break;
        case 'left':
          css.top = target.height / 2 + -offset.top - height.current / 2;
          css.left = offset.left - width.current;
          arrowObj.style.top = "".concat(height.current / 2 + (arrowoffset + arrowCorrection), "px");
          break;
        case 'top':
        default:
          css.top = -height.current - offset.top;
          css.left = target.width / 2 + offset.left - width.current / 2;
          arrowObj.style.left = "".concat(width.current / 2 + arrowoffset, "px");
          break;
      }
      return css;
    }
    css = speechBubble ? calculateSpeechBubblePosition(css) : reposition(css);
    onInit();
    Object.keys(css).forEach(e => {
      Popover.style[e] = typeof css[e] === 'number' ? "".concat(css[e], "px") : css[e];
    });
    if (closeOnOutsideClick) {
      document.addEventListener('click', e => {
        try {
          let eventParent = e.target.closest('.popover-parent');
          const popoverParent = popRef.current.closest('.popover-parent');
          while (eventParent !== null) {
            if (eventParent === popoverParent) {
              return;
            }
            eventParent = eventParent.parentElement.closest('.popover-parent');
          }
          hide();
        } catch (_unused) {}
      });
    }
    window.addEventListener('resize', () => {
      const css = speechBubble ? calculateSpeechBubblePosition({}) : reposition({});
      Object.keys(css).forEach(e => {
        Popover.style[e] = typeof css[e] === 'number' ? "".concat(css[e], "px") : css[e];
      });
    });
  }
  function toggle() {
    if (!show) {
      display();
      return;
    }
    hide();
  }
  function transitionHandleing() {
    if (!show) {
      popRef.current.style.display = 'none';
      return;
    }
    contentRef.current.style.opacity = 1;
  }
  const componentContent = React.createElement("div", {
    className: mainClassNames,
    onTransitionEnd: () => transitionHandleing(),
    ref: popRef
  }, React.createElement("div", {
    className: "arrow ".concat(arrowBranding)
  }), showCloseIcon ? React.createElement("div", {
    className: "close icon-default icon-close",
    onClick: () => close()
  }) : '', title !== undefined ? titleObject : '', React.createElement("div", {
    className: "js-popover-content popover-content",
    ref: contentRef
  }, children));
  function load() {
    popRef.current.style.position = '';
    popRef.current.style.opacity = '';
    popRef.current.style.display = speechBubble && !visible ? 'none' : '';
    if (!speechBubble) {
      popRef.current.style.width = "".concat(width.current, "px");
      popRef.current.style.height = "".concat(height.current, "px");
    }
    start(popRef.current, targetRef.current, {
      left: offset.left - offset.right,
      top: offset.top - offset.bottom
    });
    if (visible) {
      display(false);
    } else {
      hide(false);
    }
  }
  useLayoutEffect(() => {
    contentRef.current.style.height = '100%';
    popRef.current.style.opacity = 0;
    popRef.current.style.display = 'inline-block';
    popRef.current.style.position = 'static';
  }, [children]);
  useEffect(() => {
    popRef.current.style.width = '';
    popRef.current.style.height = '';
    const parent = popRef.current.getBoundingClientRect();
    width.current = parent.width + 8;
    height.current = parent.height + 8;
    load();
  }, [children]);
  return React.createElement("div", {
    className: "popover-parent ".concat(triggerClass),
    onClick: e => e.stopPropagation()
  }, React.createElement("div", {
    onClick: () => toggle(),
    ref: targetRef
  }, triggerContent), componentContent);
};
svs.components = svs.components || {};
svs.components.ReactPopover = ReactPopover;
svs.components.ReactPopover.propTypes = {
  arrowBranding: PropTypes.string,
  arrowoffset: PropTypes.number,
  branding: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  closeOnOutsideClick: PropTypes.bool,
  offset: PropTypes.shape({
    bottom: PropTypes.number,
    left: PropTypes.number,
    right: PropTypes.number,
    top: PropTypes.number
  }),
  onBeforeClose: PropTypes.func,
  onBeforeHide: PropTypes.func,
  onBeforeInit: PropTypes.func,
  onBeforeShow: PropTypes.func,
  onClose: PropTypes.func,
  onHide: PropTypes.func,
  onInit: PropTypes.func,
  onShow: PropTypes.func,
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left', 'bottom-left', 'bottom-right']),
  showCloseIcon: PropTypes.bool,
  speechBubble: PropTypes.bool,
  speechBubbleAlignment: PropTypes.oneOf(['left', 'bottom']),
  title: PropTypes.string,
  triggerClass: PropTypes.string,
  triggerContent: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  visible: PropTypes.bool
};
svs.components.ReactPopover.defaultProps = {
  arrowBranding: '',
  arrowoffset: 0,
  branding: 'popover-default',
  children: '',
  closeOnOutsideClick: false,
  offset: {
    bottom: 0,
    left: 0,
    right: 0,
    top: 0
  },
  onBeforeClose: () => {},
  onBeforeHide: () => {},
  onBeforeInit: () => {},
  onBeforeShow: () => {},
  onClose: () => {},
  onHide: () => {},
  onInit: () => {},
  onShow: () => {},
  position: 'top',
  showCloseIcon: false,
  speechBubble: false,
  speechBubbleAlignment: 'left',
  title: undefined,
  triggerClass: 'popover-trigger',
  triggerContent: React.createElement("button", {
    className: "btn btn-default",
    type: "button"
  }, "Popover"),
  visible: false
};

 })(window);